import type { KnownJsmPractice } from './KnownJsmPractice.types.tsx';

// Typed as `Set<KnownJsmPractice>` at construction so the members are checked against the union,
// then held as `ReadonlySet<string>` so membership can be tested against an arbitrary input string.
const KNOWN_JSM_PRACTICES: ReadonlySet<string> = new Set<KnownJsmPractice>([
	'CASE_MANAGEMENT',
	'CHANGE_MANAGEMENT',
	'DEVELOPER_ESCALATION',
	'INCIDENT_MANAGEMENT',
	'POST_INCIDENT_REVIEW',
	'PROBLEM_MANAGEMENT',
	'SERVICE_REQUEST',
]);

const isKnownJsmPractice = (value: string): value is KnownJsmPractice =>
	KNOWN_JSM_PRACTICES.has(value);

/**
 * Narrows an arbitrary `servicedeskPractices` string — the Relay `JiraServiceManagementPractice`
 * value, which may be `%future added value` or a practice this build doesn't recognise — to the
 * {@link KnownJsmPractice} union, returning `null` for anything unrecognised. Membership is checked
 * against a known set, so the Relay `%future added value` member is handled without naming it.
 */
export function asJsmPractice(value: string | undefined): KnownJsmPractice | null {
	if (value === undefined) {
		return null;
	}

	return isKnownJsmPractice(value) ? value : null;
}
